export default __webpack_public_path__ + "static/media/milestone 4000.fe303726.svg";